

import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { formatShipmentDate, getShipmentRouteBounds, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import {useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect} from "react"
import { setLoadItemSelect } from "../../../../features/loadList/loadListSlice"
import moment from "moment/moment"
import yayinlamaSecenekleriOptions from "../../../../utils/yukOptions/yayinlamaSecenekleriOptions"
import InputSelectLoadListYayinlamaOptions from "../../../shared/input/special/InputSelectLoadListYayinlamaOptions"
import getGivenDatePlusHours from "../../../../helper/date/getGivenDatePlusHours"
import CopyableShipmentValue from "../../../shipmentOperation/CopyableShipmentValue"
import { compactShipmentCardStyles } from "../../../shipmentOperation/shipmentCardStyles"


const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    color: ${({theme}) => theme.mainTextColor};

    .title-container{
        width: 100%;
        display: flex;
        gap: 5px;
        padding-left: 30px;
        justify-content: space-between;
        padding-bottom: 5px;

        .title-item{
            width: 15%;
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-sm);

            &:first-child{
                width: 20%;
            }

            &:last-child{
                width: 30px;
            }
        }
    }

    .content-container{
        width: 100%;
        background-color: ${({theme}) => theme.secondaryBgColor};
        display: flex;
        justify-content: space-between;
        border-radius: 10px;
        gap: 5px;
        padding: 8px 30px;
        padding-right: 0;
        cursor: pointer;
    padding-bottom: 20px;
        
        .content-column{
            display: flex;
            flex-direction: column;
            width: 15%;
            gap: 5px;

            &:first-child{
                width: 20%;
            }

            &:last-child{
                width: 30px;
                display: flex;
            }


            .content-item{
                width: 100%;
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);
                display: flex;
                align-items: center;

                .date-error{
                    color: var(--color-main);
                    font-weight: var(--font-weight-md);
                    font-size: var(--font-size-xs);
                    animation: fade 1s infinite;
                    display: block;
                    margin-left: 5px;
                }
                .more-icon{
                    font-size: 1.6rem;
                }

                .text-sm{
                    font-size: 12px;
                }
            }
            
            .outlined{
                width: max-content;
                padding: 2px 3px;
                border-radius: 5px;
                color: #fff;
                background-color: var(--color-main);
            }
        }
    }
    .location{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    @keyframes fade {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }

    ${compactShipmentCardStyles}
`

const ItemContainer = ({item: sourceItem, setActiveItemId, forwardRef, activeItemId, handleClick}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const { firstRoutePoint, lastRoutePoint } = getShipmentRouteBounds(item.routePoints)
    const dispatch = useDispatch()
    const title = ["Yükleme", "Boşaltma", "Yük", "Araç", "Diğer Bilgiler", ""]
    const navigate = useNavigate()
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    const activeItemClick = (item) => {
        // dispatch(setLoadItemSelect(item))
        setActiveItemId(item.id)
    }

    useEffect(() => {
        if(activeItemId === item.id){
            handleClick(item.id)
        }
    },[activeItemId])

    const isNotYukveren = (rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84") || (rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")

    const isPast = false

    
  return (
    <Container onClick={() => window.getSelection().toString().length < 1 && activeItemClick(item)} ref={forwardRef} id={item.id}>

       <div className="title-container">
        {
            title.map((item) => (
                <div className="title-item">{item}</div>
            ))
        }
       </div>
       <div className="content-container">
            <CopyableShipmentValue className="absolute-id" label="ID" value={item.id} />
           
            <div className="content-column">
                <div className="content-item">{formatShipmentDate(firstRoutePoint.loadDate, value => moment(value).format("DD.MM.YYYY"))} {isPast && <span className="date-error">Tarihi geçti!</span>}</div>
                <div className="content-item location">{firstRoutePoint.location}</div>
                <div className="content-item">{firstRoutePoint.displayName}</div>
            </div>
            <div className="content-column">
                <div className="content-item">{formatShipmentDate(lastRoutePoint.loadDate, value => moment(value).format("DD.MM.YYYY"))}</div>
                <div className="content-item location">{lastRoutePoint.location}</div>
                <div className="content-item">{lastRoutePoint.displayName}</div>
            </div>
            <div className="content-column">
                <div className="content-item">{item.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"}</div>
                {
                    item.LoadUnitId === 3 ? 
                    <div className="content-item">Basar Tonaj {((item.loadBulk > 0) &&` - ${item.loadBulk}`)}</div>
                    :
                    <div className="content-item">{item.loadQuantity} {item.loadUnit}</div>
                }
            </div>
            <div className="content-column">
                   <div className="content-item">{item.truckQuantity} Adet</div>
                   <div className="content-item">{item.truckType} - {item.trailerType}</div>
            </div>
            <div className="content-column">
                <CopyableShipmentValue className="copy-field" label="Konteyner No" value={item.containerNumber} />
                <CopyableShipmentValue className="copy-field" label="Mühür No" value={item.sealNumber} />
                <CopyableShipmentValue className="copy-field" label="Firma Sevk. No" value={item.companyLoadNumber} />

                {
                    (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") &&
                    <div className="content-item"onClick={(e) => e.stopPropagation()}>
                        <InputSelectLoadListYayinlamaOptions data={yayinlamaSecenekleriOptions?.find(yItem => yItem?.id === item?.publishingTypeId)} inputWidth={"max-width"} loadItem={item} labelText={""} name={"yayinlama" + item.id}/>
                    </div>
                }
                {
                    (item?.publishingTypeId === 2 && item?.scheduledPublishTime) &&
                    <div className="content-item" style={{textAlign: "center"}}>Yükün Herkese Yayınlanma Tarihi: {getGivenDatePlusHours(3, item?.scheduledPublishTime?.slice(0, -1))?.formattedDate} {getGivenDatePlusHours(3, item?.scheduledPublishTime?.slice(0, -1))?.formattedTime}</div>
                }
                <div className="content-item">{item?.projectName}</div>

            </div>
            <div className="content-column">
                {/* <div className="content-item"><MdOutlineMoreHoriz className="more-icon"/></div> */}
            </div>
       </div>


    </Container>
  )
}

export default ItemContainer
